export function getRandomInt(min: number, max: number): number {
    const minVal = Math.ceil(min);
    const maxVal = Math.floor(max);
    return Math.floor(Math.random() * (maxVal - minVal)) + minVal;
}

export function open_window(url: string, width: number, height: number): void {
    const center_left = screen.width / 2 - width / 2;
    const center_top = screen.height / 2 - height / 2;
    const thewindow = window.open(url, 'Title', `scrollbars=1, width=${width}, height=${height}, left=${center_left}, top=${center_top}`);
    thewindow?.focus();
}

export function scrollToTop(): void {
    const $j = (window as Window & { $j: { (s: string): { animate: (opts: object, animOpts: object) => void } } }).$j;
    $j('html:not(:animated), body:not(:animated)').animate({ scrollTop: 0 }, { duration: 1200, easing: 'easeInOutExpo' });
}

export function titleCase(str: string): string {
    return str
        .split('-')
        .map((i) => i[0].toUpperCase() + i.substr(1).toLowerCase())
        .join(' ');
}

export function capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertToSlug(Text: string): string {
    return Text.toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}

export function getUrlVars(): Record<string, string> {
    const vars: Record<string, string> = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (_m, key: string, value: string) => {
        vars[key] = value;
    });
    return vars;
}

export function formatPhone(phone: string | number): string {
    let digits = ('' + phone).replace(/\D/g, '');
    if (digits.length === 11 && digits[0] === '1') {
        digits = digits.substr(1);
    }
    if (digits.length !== 10) {
        return ('' + phone).replace(/[^0-9+]/g, '');
    }
    return '+1 (' + digits.substr(0, 3) + ') ' + digits.substr(3, 3) + '-' + digits.substr(6);
}

export function formatPhoneNumber(s: string | number): string | null {
    const digits = ('' + s).replace(/\D/g, '');
    let len = digits.length;
    if (len === 11 && digits[0] === '1') len = 10;
    return len === 10 ? formatPhone(s) : null;
}

export function formatPhoneInput(value: string): string {
    let digits = value.replace(/\D/g, '');
    if (digits.startsWith('1')) digits = digits.slice(1);
    digits = digits.slice(0, 10);
    if (digits.length > 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    if (digits.length > 3) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    if (digits.length) return '(' + digits;
    return '';
}

export function datasort(_data: unknown, a: string, b: string): number {
    return a.localeCompare(b);
}

(window as Window & Record<string, unknown>).getRandomInt = getRandomInt;
(window as Window & Record<string, unknown>).scrollToTop = scrollToTop;
(window as Window & Record<string, unknown>).formatPhone = formatPhone;
(window as Window & Record<string, unknown>).formatPhoneInput = formatPhoneInput;
